import _ from 'lodash';
import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import CardListing from '@/components/card-listing';
import { filterRawAlgoliaHits } from '@/components/similar-but-safer/utils/filter-raw-algolia-hits';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'makeDescription' implicitly has an 'any' type.
export const CardListings = ({ makeDescription, modelDescription, year, hits }) => {
  const vehicles = filterRawAlgoliaHits({ makeDescription, modelDescription, year, hits });
  if (_.isEmpty(vehicles)) {
    return null;
  }

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ title: string; intro: string; cars: any[]; gtmEvent: string; }' is not assignable to type 'Pick<{ cars: any; gtmEvent?: null | undefined; hasShowMoreButton?: boolean | undefined; intro?: null | undefined; onShowMoreClick?: ((...args: any[]) => void) | undefined; title?: null | undefined; }, "title" | ... 3 more ... | "onShowMoreClick">'.
    <CardListing
      {...{
        title: 'Similar but safer',
        intro: 'Similar size, similar price range, but a safer option.',
        cars: vehicles,
        gtmEvent: 'similarButSafer',
      }}
    />
  );
};

const ConnectedCardListings = connectHits(CardListings);

export default ConnectedCardListings;
